import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';

import { useDispatch, useSelector } from 'src/store';
import { applyVoucher } from 'src/slices/cart';
import { formatPrice } from 'src/utils';
import classes from './VoucherRecommendations.module.scss';
import textClasses from 'src/styles/text.module.scss';

const VoucherRecommendations: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { voucherRecommendations, appliedVoucher } = useSelector((state) => state.cart);

  if (!voucherRecommendations.length || appliedVoucher) return null;

  return (
    <div className={classes.container}>
      {voucherRecommendations.map((rec) => (
        <div key={rec.voucherCode} className={classes.item}>
          {rec.freeProduct.imageUrl && (
            <img src={rec.freeProduct.imageUrl} alt={rec.freeProduct.name} className={classes.productImage} />
          )}
          <div className={classes.content}>
            <span className={textClasses.textM}>
              {rec.freeQuantity > 1
                ? t('Free {{count}}x {{product}} with this order', {
                    count: rec.freeQuantity,
                    product: rec.freeProduct.name,
                  })
                : t('Free {{product}} with this order', { product: rec.freeProduct.name })}
            </span>
            <span className={classes.savings}>{t('Save {{amount}}', { amount: formatPrice(rec.savingsAmount) })}</span>
          </div>
          <IonButton
            fill="outline"
            color="primary"
            className={classes.applyBtn}
            onClick={() => dispatch(applyVoucher(rec.voucherCode))}
          >
            {t('Apply')}
          </IonButton>
        </div>
      ))}
    </div>
  );
};

export default VoucherRecommendations;
